import { ifDefined } from 'lit/directives/if-defined.js';
import { LitElement, html } from '@fil-global/webcomponents-base';
import { renderHideLink } from '@fil-global/webcomponents-base/src/template.js';
import { enterSpaceKeys } from '@fil-global/shared/src/util';
import componentStyles from './fil-card-content.styles.js';
/**
 * @tag fil-card-content
 * @property {string} [url] URL the CTA button in the component
 */
export class FilCardContent extends LitElement {
  static properties = {
    // Deprecated, the card content should use the target url in fil-card-footer if available, it's useless now.
    url: { type: String },
    target: { type: String },
  };

  static styles = [componentStyles];

  handleKeyDown(event) {
    if (enterSpaceKeys(event) && this.url) {
      const hideLink = this.shadowRoot.querySelector('#hideLink');
      hideLink.click();
    }
  }

  slotChangeHandler(event) {
    const slot = event.target;
    const cardContent = slot?.assignedNodes();
    if (cardContent?.length === 0) {
      slot.parentElement?.setAttribute('tabindex', '-1');
    }
  }

  render() {
    return html`<div
      class="fil-card__content"
      @keydown=${this.handleKeyDown}
      ?clickable=${ifDefined(this.url)}
    >
      ${renderHideLink(this.url, this.target)}
      <div
        class="fil-card__headline"
        tabindex="${this.url ? '0' : '-1'}"
        role=${ifDefined(this.url ? 'link' : undefined)}
      >
        <slot name="title"></slot>
      </div>
      <p
        class="fil-card__subtext"
        tabindex="${this.url ? '0' : '-1'}"
        role=${ifDefined(this.url ? 'link' : undefined)}
      >
        <slot @slotchange=${this.slotChangeHandler}></slot>
      </p>
    </div>`;
  }
}

export default FilCardContent;
